<template>
  <div>
    <!-- 选择专享价活动-->
    <jd-dialog
      title="选择专享价活动"
      :visible.sync="value"
      append-to-body
      width="50%"
      @close="handlerClose"
    >
      <jd-form
        ref="jdForm"
        :form-info="formInfo"
        @search="searchExclusivePriceDetail"
      />
      <jd-button @click="addSpecialPrice" type="blue" style="margin-top: 12px;">新增专享价</jd-button>
      <jd-table
        class="token-table"
        ref="checkTable"
        :tableData="dataList"
        :loading="tableDetailLoading"
        :tableInfo="tableInfo"
        :pageInfo="{
          pageSize: formList.size,
          pageNum: formList.current,
          total: totalDetail,
        }"
        style="margin-top: 12px"
        @handlePage="handlePage"
        @select="handleSelectionChange"
        :selection="true"
        rowKey="id"
        :selectable="selectable"
        :maxHeight="450"
      >
        <template v-slot:priceSlot="scope">
          <div>
            京东价：{{
              scope.row.skuNum > 1
                ? `${scope.row.minJdPrice}~${scope.row.maxJdPrice}`
                : scope.row.minJdPrice
            }}
          </div>
          <div>
            折扣价：{{
              scope.row.skuNum > 1
                ? `${scope.row.minPayPrice}~${scope.row.maxPayPrice}`
                : scope.row.minPayPrice
            }}
          </div>
        </template>
        <template #activityTimeSlot="scope">
          <span>起：{{ scope.row.startTime }}</span
          ><br />
          <span>止：{{ scope.row.endTime }}</span>
        </template>
        <template v-slot:skuSlot="scope">
          <jd-button type="blueText" @click="checkSku(scope.row)"
            >{{ scope.row.skuNum }}个</jd-button
          >
        </template>
        <template #statusSlot="scope">
          <div>
            {{
              scope.row.status == 0
                ? "待生效"
                : scope.row.status == 1
                ? "已生效"
                : scope.row.status == 2
                ? "已失效"
                : "已停止"
            }}
          </div>
        </template>
      </jd-table>
      <div slot="footer" class="dialog-footer">
        <jd-button @click="confirmSure" type="blue">确 定</jd-button>
        <jd-button @click="$emit('input', false)">取 消</jd-button>
      </div>
    </jd-dialog>
    <!-- 商品详细 -->
    <goodsDetail
      :isShow.sync="isShowSkuDialog"
      :goodsData="goodsData"
    ></goodsDetail>
  </div>
</template>
<script>
import { getExclusivePricePlanPage } from "@/api/jhk/integralCenter/prizeCenter.js";
import goodsDetail from "@/views/interactiveMarketing/components/specialPrice/components/goodsDetail.vue";
export default {
  name: "selectTokenDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    exclusivePriceId: {
      type: String,
      default: "",
    },
    isSetDisabled: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    exclusivePriceId: {
      handler(val) {
        if (val) {
          this.ids = val;
        }
        this.getExclusivePriceDetail();
      },
      immediate: true,
    },
  },
  created() {},
  mounted() {},
  components: {
    goodsDetail,
  },
  data() {
    return {
      selectedRows: [],
      goodsData: [],
      isShowSkuDialog: false,
      totalDetail: 0,
      tableDetailLoading: false,
      formList: {
        current: 1,
        size: 10,
        name: "",
        createStartTime: "",
        createEndTime: "",
        status: 1,
        queryType: 0,
      },
      dataList: [],
      tableInfo: [
        {
          label: "专享价名称",
          prop: "name",
          minWidth: 120,
        },
        {
          label: "优惠价格",
          prop: "price",
          slot: "priceSlot",
          minWidth: 160,
        },
        {
          label: "活动时间",
          prop: "activityTime",
          slot: "activityTimeSlot",
          minWidth: 160,
        },
        {
          label: "商品SKU",
          prop: "sku",
          slot: "skuSlot",
          minWidth: 100,
        },
        {
          label: "发放总量（人数）",
          prop: "quantityTotal",
          minWidth: 130,
        },
        {
          label: "已发放人数",
          prop: "grantNum",
          minWidth: 100,
        },
        {
          label: "剩余数量（人数）",
          prop: "quantityBalance",
          minWidth: 130,
        },
        {
          label: "时效状态",
          prop: "status",
          slot: "statusSlot",
          minWidth: 100,
        },
      ],
      formInfo: [
        {
          label: "专享价名称：",
          prop: "name",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "商品SKU：",
          prop: "skuId",
          type: "Input",
          isNumber: true,
          placeholder: "请输入",
        },
        // {
        //   label: "状态：",
        //   prop: "status",
        //   type: "Select",
        //   value: "",
        //   options: [
        //     { label: "全部", value: "" },
        //     { label: "待生效", value: 0 },
        //     { label: "已生效", value: 1 },
        //   ],
        // },
        {
          label: "创建时间：",
          prop: "dateRange2",
          type: "DateRange",
          dateType: "datetime",
          startKey: "createStartTime",
          endKey: "createEndTime",
          defalutLimit: true,
        },
      ],
      selectTokenDialog: false, //令牌
    };
  },
  computed: {},
  methods: {
    checkSku(row) {
      this.goodsData = row.skuList;
      this.isShowSkuDialog = true;
    },
    addSpecialPrice() {
      const routeUrl = this.$router.resolve({
        path: "/tool/prizeCenter/assetManagement",
        query: { tabAct: 9 },
      });
      window.open(routeUrl.href, "_blank");
    },
    selectable(row) {
      // 外传状态是否已结束的禁用
      if (!this.isSetDisabled) {
        return true;
      } else {
        return row.status != 3;
      }
    },
    //选择专享价活动
    handleSelectionChange(selection, val) {
      this.$refs.checkTable.handleClearSelection();
      this.$refs.checkTable.toggleRowSelection(val, true);
      this.selectedRows = [val];
      this.ids = this.selectedRows[0] && this.selectedRows[0].id;
    },
    //分页变化事件
    handlePage(val) {
      this.formList.size = val.pageSize;
      this.formList.current = val.pageNum;
      this.getExclusivePriceDetail();
    },
    searchExclusivePriceDetail(val) {
      this.formList = { ...val, current: 1, size: 10, queryType: 0,status: 1 };
      this.getExclusivePriceDetail();
    },
    //获取专享价活动
    async getExclusivePriceDetail() {
      this.tableDetailLoading = true;
      try {
        const res = await getExclusivePricePlanPage(this.formList);
        if (res.code == 1) {
          this.tableDetailLoading = false;
          this.dataList = res.data.records;
          this.totalDetail = Number(res.data.total);
          const row = this.dataList.find((v) => v.id == this.ids);
          if (row) {
            this.$nextTick(() => {
              this.$refs.checkTable.toggleRowSelection(row, true);
            });
            this.selectedRows = [row];
          }
        } else {
          this.tableDetailLoading = false;
        }
      } catch (error) {
        this.tableDetailLoading = false;
      }
    },
    //选择令牌
    confirmSure() {
      const ids = (this.selectedRows[0] && this.selectedRows[0].id) || this.ids;
      if (!ids) {
        return this.$message.error("请先选择专享价活动");
      }
      this.$emit("confirm", { ...this.selectedRows[0], id: this.ids });
      // this.handlerClose();
    },
    handlerClose() {
      this.$emit("input", false);
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .token-table .el-table__header-wrapper th .cell .el-checkbox {
  display: none;
}
</style>
